import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import RouletteWheel from './RouletteWheel';
import { calculateWinner } from './rouletteUtils';
import WinnerDialog from './WinnerDialog';


function App() {

  const [fullscreen, setFullscreen] = useState(false);

  const [items, setItems] = useState([]);
  const [rotation, setRotation] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [showDialog, setShowDialog] = useState(false);


  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);

      const parsedItems = data.map(item => ({
        name: item.이름,
        visualWeight: Number(item.시각비율),
        probability: Number(item.당첨확률),
      }));

      setItems(parsedItems);
    };

    reader.readAsBinaryString(file);
  };
  const spin = () => {
    if (spinning || items.length === 0) return;
    setSpinning(true);
    setSelectedItem(null);
    const spinSound = new Audio('/sounds/spin.mp3');
    const stopSound = new Audio('/sounds/stop.mp3');
    spinSound.play();
  
    const { winner, finalRotation } = calculateWinner(items, rotation);
    setRotation(finalRotation);
  
    setTimeout(() => {
      spinSound.pause();
      spinSound.currentTime = 0;
      stopSound.play();
      setSpinning(false);
      setSelectedItem(winner);
      setShowDialog(true);
    }, 4000);
  };
  

  return (
    <>
      <button
        onClick={() => setFullscreen(prev => !prev)}
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          padding: '10px 20px',
          fontSize: '14px',
          zIndex: 1100,
          cursor: 'pointer',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '6px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        }}
      >
        {fullscreen ? '닫기' : '전체화면'}
      </button>

      {fullscreen ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: 'url(/assets/background.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: 999,
          }}
        >
          <RouletteWheel
            items={items}
            rotation={rotation}
            spinning={spinning}
            onSpin={spin}
            selectedItem={selectedItem}
          />
          <WinnerDialog
            winner={selectedItem}
            open={showDialog}
            onClose={() => setShowDialog(false)}
          />
        </div>
      ) : (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: 'url(/assets/background.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: 1,
          }}
        >
          <div style={{ flex: 1, padding: 20, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <h2>매일경제 자이앤트TV 룰렛</h2>
            <div style={{ marginTop: 10 }}>
              <label>엑셀 파일 업로드: </label>
              <input type="file" onChange={handleFileUpload} />
            </div>
          </div>


          <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <RouletteWheel
              items={items}
              rotation={rotation}
              spinning={spinning}
              onSpin={spin}
              selectedItem={selectedItem}
            />
          </div>

          <WinnerDialog
            winner={selectedItem}
            open={showDialog}
            onClose={() => setShowDialog(false)}
          />
        </div>
      )}
    </>
  );
}
export default App;
